import React from "react";
import { modal } from "../modal";

export const modal_phone_call = props => {
  const { contactType, asset, room } = props;
  console.log(asset)
  // {room ? ' ' + room.roomName : ''}
  return (
    <div className="modal_phone_call modal_base">
      <div className="cross" onClick={() => modal.closeModal()} />
      { asset && <div className="phone_guide">お電話の際【{asset.name}】とオペレータへお伝えください。</div> }
      <div className="phone_number">
        {contactType.phoneNumber}
      </div>
      { contactType.phoneDescription1 && <div className="phone_description">
        {contactType.phoneDescription1}<br/>
      </div>}
      { contactType.phoneDescription2 && <div className="phone_description">
        {contactType.phoneDescription2}<br/>
      </div>}
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/modal/modal_phone_call.jsx